export type TermsSection = {
  id: string;
  number: string;
  title: string;
  subsections: {
    title: string;
    content: string;
  }[];
};

export const TERMS_SECTIONS: TermsSection[] = [
  {
    id: "services",
    number: "1",
    title: "Services and Support",
    subsections: [
      {
        title: "1.1 Services",
        content:
          '"Services" means the ZOM AI products and services that are made available to Customer by ZOM hereunder, including but not limited to financial research, analysis tools, portfolio insights, client management features, and related software and documentation. Subject to the terms and conditions of this MSA, ZOM will make the Services available to Customer for the service period of Customer\'s subscription specified on the applicable Order Form ("Service Period").',
      },
      {
        title: "1.2 Support",
        content:
          "ZOM will provide commercially reasonable support during the Service Period in accordance with ZOM's standard support practices.",
      },
    ],
  },
  {
    id: "fees",
    number: "2",
    title: "Fees and Payment",
    subsections: [
      {
        title: "2.1 Payment and Taxes",
        content:
          '"Fees" means the fees payable by Customer to ZOM for the applicable Services, as set forth on the Order Form. Customer is responsible for all Fees set forth in the Order Form. In the event of non-payment of Fees by Customer for fifteen (15) days after the due date of an invoice, ZOM reserves the right to immediately suspend Customer\'s access to the Services until Customer pays the entire remaining balance of Fees.',
      },
      {
        title: "2.2 Taxes",
        content:
          "Fees do not include taxes, levies, duties or similar governmental assessments of any nature. Customer is responsible for paying all Taxes associated with its purchase of the Services, excluding Taxes based on ZOM's net income or receipts, property or employees.",
      },
    ],
  },
  {
    id: "term",
    number: "3",
    title: "Term and Termination",
    subsections: [
      {
        title: "3.1 Term and Renewal",
        content:
          "This MSA commences on the Effective Date and will remain in effect until all Order Forms have expired or been terminated. The Service Period for each Order Form shall be set forth therein; provided that if the Order Form does not specify a Service Period, the Service Period will be one (1) year. Upon expiration of the Service Period, the Customer's subscription will automatically renew for successive one- (1) year Service Periods unless Customer provides ZOM with notice of termination at least thirty (30) days prior to the end of the then-current Service Period.",
      },
      {
        title: "3.2 Termination for Cause",
        content:
          "A Party may terminate this MSA or an Order Form for cause (a) upon written notice to the other Party of a material breach if such breach remains uncured after ten (10) days from the date of the breaching Party's receipt of such notice; or (b) if the other Party becomes the subject of a petition in bankruptcy or any other proceeding relating to insolvency, receivership, liquidation or assignment for the benefit of creditors.",
      },
      {
        title: "3.3 Document Retention and Deletion Requests",
        content:
          "Customer documents, files, and other materials uploaded to the Services will be retained by ZOM until Customer submits a deletion request through the Settings page in the Services. Following receipt and verification of a valid request, ZOM will delete or anonymize the requested materials subject to any legal, regulatory, or contractual retention obligations.",
      },
    ],
  },
  {
    id: "ownership",
    number: "4",
    title: "Ownership, License, and Use",
    subsections: [
      {
        title: "4.1 Ownership",
        content:
          "Each Party will retain all rights, title and interest in its intellectual property. ZOM will retain all intellectual property rights in and to the Services. Customer will retain intellectual property rights in all information uploaded to the Services by or on behalf of Customer, including any outputs or results produced by the Services from such information (excluding any ZOM intellectual property embedded therein).",
      },
      {
        title: "4.2 Licenses",
        content:
          "Subject to Customer's compliance with the terms and conditions of this MSA, ZOM hereby grants Customer a non-exclusive, non-transferable, non-sublicensable limited right and license to access and use the Services solely during the applicable Service Period for Customer's internal business purposes.",
      },
    ],
  },
];

export const AI_DISCLAIMER_ITEMS = [
  "AI Outputs are generated using automated systems and may contain errors, inaccuracies, or incomplete information",
  "AI Outputs should be independently verified and validated before use",
  "AI Outputs may not reflect current market conditions, regulations, or best practices",
  "AI Outputs are not personalized investment advice and do not constitute a recommendation to buy, sell, or hold any security or pursue any investment strategy",
  "ZOM makes no representations or warranties regarding the accuracy, completeness, timeliness, or suitability of AI Outputs for any purpose",
  "Customer, as a licensed financial professional, bears sole responsibility for independently verifying all AI Outputs, exercising professional judgment, and ensuring the accuracy and appropriateness of any information before presenting it to or acting on behalf of clients",
  "Customer's use of any AI Output in connection with client advice, recommendations, or transactions is at Customer's own risk and sole discretion",
];
